import ModulePlugin from './lib/index'

export default ModulePlugin
